import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    CardText
} from "reactstrap"
import { SuccessOk, SuccessCreated } from "configs/statusCode"
import { AvForm, AvField, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import { toast } from "react-toastify"
import DealService from "services/Admin/DealService"


function ModalForm({ modal, toggle, status, id,multi, idsSelected, setShouldGetData }) {
    const [formData, setFormData] = useState({
        status: ""
    })
    const dealService = new DealService()
    const [loading, setLoading] = useState(false)


    useEffect(() => {
        if(!multi) setFormData({ ...formData, status })
    }, [status])

    const handleFieldChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    const ChangeStatusHandler = (_, values) => {
        setLoading(true)
        if(multi){
            let data = {
                ...formData,
                deal_ids: idsSelected
            }
            dealService.updateMultiDeals(data).then(res => {
                if (res.status) {
                    setShouldGetData(true)
                    toast.success("Status Changed successfully")
                    toggle()
                }else {
                    setLoading(false)
                }
            }).catch(()=> setLoading(false))
            return
        }
        dealService.update(id, formData).then(res => {
            if (res && res.status === SuccessOk) {
                setShouldGetData(true)
                toast.success("Status changed successfully")
                toggle()
            }else {
                setLoading(false)
              }
        })
    }
    return (
        <AvForm
            className='form-horizontal'
            onValidSubmit={(e, v) => {
                handleValidSubmit(e, v)
            }}>
            <Modal isOpen={modal} toggle={toggle} className="scrollbar-container mt-5">
                <ModalHeader toggle={toggle}>
                    Change Status
                <br />
                    <span className="font-size-14" style={{ opacity: .5, }}>Change Status of the leads</span>
                </ModalHeader>
                <ModalBody>

                    <Row>
                        <Col className="m-0">
                            <CardText tag='h6' className='fw-bold'>
                                Status
                  </CardText>
                            <AvRadioGroup className="mt-2" name="status" value={formData.status} onChange={handleFieldChange} >
                                <AvRadio label="Uncontacted" value="Uncontacted" />
                                <AvRadio label="Contacted" value="Contacted" />
                                <AvRadio label="Unreachable" value="Unreachable" />
                                <AvRadio label="Open" value="Open" />
                                <AvRadio label="Pending" value="Pending" />
                                <AvRadio label="Closed" value="Closed" />
                                <AvRadio label="Won" value="Won" />
                                <AvRadio label="Lost" value="Lost" />
                            </AvRadioGroup>
                        </Col>
                    </Row>
                </ModalBody>

                <ModalFooter className="p-0 pt-1 m-0 d-flex justify-content-end">
                    <button
                        type='button'
                        onClick={toggle}
                        className='btn btn-secondary'>
                        Cancel
                        </button>
                    <button
                        type='button'
                        onClick={ChangeStatusHandler}
                        disabled={loading ? true:false}
                        className='btn btn-success'>
                        Submit
                        </button>
                </ModalFooter>
            </Modal>
        </AvForm>

    )
}

export default ModalForm
